Drupal.behaviors.sw_icons_slider = {
  attach: function( context, settings ) {

    $('.icons-slider').once('sw_icons_slider').each(function() {
      let $wrap = $(this);
      let $slider = $wrap.find('.icons-slider__slider');
      const slides_count = $slider.find('.icons-slider__slide').length;
      $slider.slick({
        arrows: true,
        fade: false,
        dots: false,
        adaptiveHeight: false,
        infinite: false,
        touchMove: false,
        swipe: true,
        centerMode: false,
        slidesToShow: 1,
        variableWidth: true,
        waitForAnimate: false,
        speed: 400,
        appendArrows: $wrap.find('.slick-arrows'),
      });
      setTimeout(function() {
        $slider[0].slick.updateArrows();
      }, 500);


    });

  }
};
